export const state = {
    results: {
        area: null,
        volume: null,
        litres: null,
        per_litre: null,
        coats: null,
    },
    info: {
        handle: null,
        coverage: null,
        comments: null,
    },
    has_results: false,
}

export const mutations = {
    SET_DATA(state, { info, results }) {
        state.info = info
        state.results = results
        state.has_results = true
    },
    RESET(state) {
        state.info = {
            handle: null,
            coverage: null,
            comments: null,
        }
        state.results = {
            area: null,
            volume: null,
            litres: null,
            per_litre: null,
            coats: null,
        }
        state.has_results = false
    },
}

export const actions = {}
